if (typeof document !== 'undefined') {
    if (document.currentScript && document.currentScript.src) {
        document.currentScript.src = document.currentScript.src.split('?')[0];
    } else if (document.baseURI) {
        document.baseURI = document.baseURI.split('?')[0];
    }
}
export default import.meta.ROLLUP_ASSET_URL_21cf7a95;